import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { cn } from '@/lib/utils';
import {type PageWidth, widthClasses} from "./Page.tsx";

interface PageHeaderProps {
    title: string | React.ReactNode;
    backLink?: string;
    onBack?: () => void;
    actions?: React.ReactNode;
    width?: PageWidth;
    className?: string;
}

export function PageHeader({
                               title,
                               backLink,
                               onBack,
                               actions,
                               width = 'standard',
                               className
                           }: PageHeaderProps) {
    const navigate = useNavigate();

    const handleBack = () => {
        if (onBack) {
            onBack();
            return;
        }
        const hasInternalHistory = (window.history.state?.idx ?? 0) > 0;
        if (hasInternalHistory) {
            navigate(-1);
        } else if (backLink) {
            navigate(backLink);
        }
    };

    const showBack = backLink || onBack;

    return (
        <div className={cn(
            "sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-100 transition-all",
            className
        )}>
            <div className={cn("mx-auto px-4 py-4 flex items-center justify-between h-16", widthClasses[width])}>

                {/* Gauche : Retour + Titre */}
                <div className="flex items-center gap-3 min-w-0">
                    {showBack && (
                        <button
                            onClick={handleBack}
                            className="p-2 hover:bg-slate-100 rounded-full transition-colors text-slate-600 flex-shrink-0"
                        >
                            <ChevronLeft size={24} />
                        </button>
                    )}

                    {typeof title === 'string' ? (
                        <h1 className="text-lg md:text-xl font-black text-slate-900 tracking-tight truncate">
                            {title}
                        </h1>
                    ) : (
                        <div className="min-w-0 flex-1">
                            {title}
                        </div>
                    )}
                </div>

                {/* Droite : Actions */}
                {actions && (
                    <div className="flex items-center gap-2 flex-shrink-0">
                        {actions}
                    </div>
                )}
            </div>
        </div>
    );
}
